import { useTranslation } from 'react-i18next';

import { DownloadButton } from './DownloadButton';

import {
  Table,
  TableBody,
  TableCellWithTooltip,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/Table';
import { useGetCategoriesSeo } from '@/hooks/useGetCategoriesSeo';

export function CategoriesTable() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.SeoContent.components.CategoriesTable',
  });
  const { categoriesSeo } = useGetCategoriesSeo();

  if (categoriesSeo.length === 0) {
    return null;
  }

  return (
    <div className="space-y-4">
      <DownloadButton />

      <div className="rounded-md border">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>{t('id')}</TableHead>
              <TableHead>{t('name')}</TableHead>
              <TableHead>{t('title')}</TableHead>
              <TableHead>{t('description')}</TableHead>
              <TableHead>{t('keywords')}</TableHead>
            </TableRow>
          </TableHeader>

          <TableBody>
            {categoriesSeo.map((category) => (
              <TableRow key={category.category_id}>
                <TableCellWithTooltip>
                  {category.category_id}
                </TableCellWithTooltip>

                <TableCellWithTooltip>{category.name}</TableCellWithTooltip>

                <TableCellWithTooltip>{category.title}</TableCellWithTooltip>

                <TableCellWithTooltip>
                  {category.description}
                </TableCellWithTooltip>

                <TableCellWithTooltip>{category.keywords}</TableCellWithTooltip>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
